import { render, staticRenderFns } from "./ColorSwatches.vue?vue&type=template&id=8cb414cc&"
import script from "./ColorSwatches.vue?vue&type=script&lang=js&"
export * from "./ColorSwatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports